<!--
 * @Description: 发言嘉宾
 * @Date: 2024-07-31 09:08:01
 * @LastEditTime: 2024-09-10 11:58:30
 * @LastEditors:  
-->
<template>
  <div class="main-container">
    <page-header>{{'CSGCT核心专家库' | dealLanguage('Speakers')}}</page-header>
    <div class="speakers">
      <speaker-item v-for="item in guestDtoList" :key="item.id" :itemDetail="item"></speaker-item>
    </div>
    <Spin v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="over-p" v-if="!more && !loading && guestDtoList.length">{{'已经到底了~' | dealLanguage('No more content to load.')}}</div>
    <div class="nodata" v-if="!loading && !guestDtoList.length">
      <p>当前页面暂无内容</p>
    </div>
    <div ref="indexlist-bottom"></div>
  </div>
</template>

<script>
import PageHeader from '@/components/mobile/pageHeader.vue'
import { mapState } from 'vuex'
import SpeakerItem from '@/components/index/speakerItem.vue'
import { getActExhibitionAllGuest } from '@/service/vbef'
import filter from 'js/filter'
export default {
  metaInfo() {
    return {
      title: this.language == 'zh' ? '发言嘉宾' : 'Previous Guests',
    }
  },
  data() {
    return {
      guestDtoList: [],
      loading: false,
      page: 1,
      more: true,
    }
  },
  components: {
    PageHeader,
    SpeakerItem,
  },
  computed: {
    ...mapState({
      user_key: (state) => state.user_key,
      user: (state) => state.user,
      activityId: (state) => state.activityId,
      language: (state) => state.language,
    }),
  },
  created() {
    this.getActExhibitionAllGuest()
  },
  mounted() {
    this.wxShare({
      title: filter.dealLanguage('发言嘉宾-CSGCT', 'Previous Guests-CSGCT'),
      linkurl: this.vbef_path + '/guests',
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    async getActExhibitionAllGuest() {
      this.loading = true
      let res = await getActExhibitionAllGuest({
        activityId: this.activityId,
        getCount: false,
        page: this.page,
        size: 20,
      })
      this.loading = false
      if (res.code == 0) {
        this.guestDtoList = [...this.guestDtoList, ...res.data.guestDtos]
        this.more = res.data.guestDtos.length == 20
      } else {
        this.$Messager.error(filter.dealLanguage(res.msg, res.enMsg || res.msg))
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight

      const listbox = this.$refs['indexlist-bottom']
      const listrect = listbox.getBoundingClientRect()
      const listabsoluteTop = listrect.top + scrollTop

      if (
        scrollTop + windowHeight > listabsoluteTop &&
        scrollTop > 0 &&
        !this.loading &&
        this.more
      ) {
        this.handleMore()
      }
    },
    handleMore() {
      this.page++
      this.getActExhibitionAllGuest()
    },
  },
}
</script>
<style lang='stylus' scoped>
@import '~styles/common-m.styl'
.main-container
  padding-bottom .4rem
  >>> .ivu-spin
    background #fff
    margin-top .3rem
  >>> .over-p
    margin-top .3rem
    color #999999
    line-height .82rem
    text-align center
  .nodata
    padding .6rem 0
    text-align center
    font-size 0
    p
      font-size .28rem
      color #666666
      line-height 1.5
.speakers
  margin-top 0.4rem
  padding 0 0.4rem
  display grid
  grid-template-columns repeat(2, 1fr)
  grid-gap 0.3rem 0.3rem
  & > :nth-child(2n+1)
    justify-self end
  & > :nth-child(2n)
    justify-self start
  >>> .speaker-item
    width 100%
    max-width 3.8rem
    min-width auto
    padding 0 0 0.4rem
    .header-img
      width 80%
      height 0
      padding-bottom 80%
      margin-top 20%
      max-height 3.8rem
      position relative
      img
        position absolute
    .name
      font-size 0.3rem
      line-height 0.42rem
      margin-top 0.22rem
      padding 0 0.4rem
    .title
      font-size 0.24rem
      line-height 0.36rem
      margin-top 0.11rem
      padding 0 0.4rem
      min-height 0.72rem
</style>